import { useEffect } from 'react'

const DEFAULT_TITLE = 'QuickMD'

type PatientNameFields = {
  FirstName?: string | null
  LastName?: string | null
}

export function useDashboardDocumentTitle({
  isVisitPopUpOpen,
  patient,
}: {
  isVisitPopUpOpen: boolean
  patient?: PatientNameFields | undefined
}) {
  const firstName = patient?.FirstName ?? ''
  const lastName = patient?.LastName ?? ''

  useEffect(() => {
    if (isVisitPopUpOpen) {
      const fullName = `${firstName} ${lastName}`.trim()
      document.title = fullName ? `Visit with ${fullName}` : 'Visit In-Progress'
      return
    }
    document.title = DEFAULT_TITLE
  }, [isVisitPopUpOpen, firstName, lastName])
}
